import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const CloudIcon = forwardRef<SVGSVGElement, IconProps>(function CloudIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.74974 4.28243C3.54537 4.19843 3.32792 4.30897 3.26406 4.52934L3.63412 4.68144C3.26406 4.52934 3.26407 4.5293 3.26406 4.52934L3.26377 4.53033L3.26325 4.53215L3.26153 4.53818L3.2556 4.55937C3.25063 4.57736 3.24369 4.60291 3.23544 4.63453C3.21899 4.69756 3.19708 4.7857 3.17511 4.8867C3.13321 5.07929 3.08316 5.35343 3.08336 5.59245C3.08371 6.01937 3.13161 6.29426 3.27707 6.69264C3.35855 6.91582 3.58513 7.03496 3.78313 6.95875C3.98114 6.88254 4.0756 6.63983 3.99411 6.41665C3.88813 6.12639 3.85901 5.96297 3.85875 5.64403C3.85864 5.51002 3.89011 5.31577 3.92983 5.13321C3.94866 5.04664 3.96757 4.97052 3.98175 4.91619C3.98881 4.88912 3.99463 4.86772 3.99859 4.85342L4.00303 4.83755L4.00404 4.83399C4.06786 4.61364 3.9541 4.36643 3.74974 4.28243Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33465 4.06731C3.9962 2.3058 5.53213 1 7.44828 1C10.0016 1 12 3.30432 12 5.9959C12 8.6578 10.0042 11.0309 7.4456 10.9997H3.31034C1.5208 10.9997 0 9.49951 0 7.60481C0 5.75543 1.37505 4.0646 3.2069 4.0646C3.24965 4.0646 3.29224 4.06551 3.33465 4.06731ZM7.44828 1.79799C5.8768 1.79799 4.53391 2.93746 4.02015 4.61077C3.96068 4.80448 3.76043 4.92476 3.55389 4.89084C3.44065 4.87223 3.3248 4.86259 3.2069 4.86259C1.95356 4.86259 0.827586 6.06913 0.827586 7.60481C0.827586 9.09518 2.01471 10.2017 3.31034 10.2017H7.45381C9.42947 10.2272 11.1724 8.34244 11.1724 5.9959C11.1724 3.63546 9.43861 1.79799 7.44828 1.79799Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
